import request from './request';

export const scheduleApi = {
  // 获取日程列表
  getList: (params) => request.get('/schedules', { params }),
  
  // 创建日程
  create: (data) => request.post('/schedules', data),

  // 批量排期
  batchCreate: (data) => request.post('/schedules/batch', data),
  
  // 更新日程
  update: (id, data) => request.put(`/schedules/${id}`, data),
  
  // 删除日程
  delete: (id) => request.delete(`/schedules/${id}`),
  
  // 获取即将到期的日程（首页用）
  getUpcoming: (days = 7) => request.get('/schedules/upcoming', { params: { days } }),
  
  // 标记日程完成
  complete: (id) => request.post(`/schedules/${id}/complete`),

  // 日历计划一键投递（上报+完成，原子事务）
  reportDelivery: (id, data) => request.post(`/schedules/${id}/report-delivery`, data),

  // 撤销日历投递（回退投递数+状态）
  undoDelivery: (id) => request.post(`/schedules/${id}/undo-delivery`)
};